<script setup lang="ts">
import type { LoginTabType } from '@xianlaibang/shared/types'

/**
 * 登录页面SEO设置,不需要响应式
 * @description 设置登录页面的 SEO 元数据，包括标题、描述和预览图像。
 * 
 */
if (import.meta.server) {
  useSeoMeta({
    title: '闲来帮-登录',
    ogTitle: '闲来帮-登录',
    description: '登录闲来帮，享受便捷的生活服务。已有账号？直接登录。新用户？立即注册加入我们。',
    ogDescription: '登录闲来帮，享受便捷的生活服务。已有账号？直接登录。新用户？立即注册加入我们。',
    ogImage: 'https://example.com/login-preview.png',
  })
}

definePageMeta({
  layout: 'login',
  title: 'Login Page',
})

/**
 * 当前显示的登录选项卡
 */
const currentTab = ref<LoginTabType>('PwdLogin');

/**
 * 切换登录选项卡
 * @param tab - 要切换到的选项卡名称
 */
function handleToggle(tab: LoginTabType) {
  currentTab.value = tab
}

</script>
<template>
  <div class="login-container">
    <LazyLoginPwdLogin v-if="currentTab  === 'PwdLogin'" @toggle="handleToggle"/>
    <LazyLoginVerifyLogin v-if="currentTab === 'VerifyLogin'" @toggle="handleToggle"/>
    <LazyLoginSetPwd v-if="currentTab == 'SetPwd'" @toggle="handleToggle"/>
    <LazyLoginResetPwd v-if="currentTab == 'ResetPwd'" @toggle="handleToggle"/>
    <LazyLoginWechatLogin v-if="currentTab == 'WechatLogin'" @toggle="handleToggle"/>
    <LazyLoginRegisterAccount v-if="currentTab == 'RegisterAccount'" @toggle="handleToggle"/>
  </div>
</template>
<style lang="scss">
@use "@/assets/scss/login.scss";
</style>

